function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * 提示用户的自定义属性，不能与已有的核心上报字段重复
 *
 * @file forbiddenWords.js
 * @author leibin@baijia.com
 *
 */
import { isTestReg } from './env';
import { commonParamsFromApp } from './appCommonParam';
var protectedKeys = ['env', 'name', // 记录当前使用的哈勃版本信息， 比如2.2.1
'ver', // 当前设备（浏览器）的唯一标识
'gid', // 时间戳
't', // 请求序号
'req_idx' // stay 中固定 at、bt、tt暂不考虑
];

if (Object.keys(commonParamsFromApp).length > 0) {
  protectedKeys = [].concat(_toConsumableArray(protectedKeys), _toConsumableArray(Object.keys(commonParamsFromApp).map(function (key) {
    return key.toLowerCase();
  })));
}
/**
 * 如果自定义事件属性含有受保护的上报字段 (name, env, version 等)，就会有warning提示，但是不阻断上报
 *
 * @params {Object} eventAttr 自定义事件上报属性对象
 */


export default function warnForbiddenKeys(eventAttr) {
  if ((typeof location === "undefined" ? "undefined" : _typeof(location)) === 'object' && isTestReg.test(location.hostname)) {
    setTimeout(function () {
      Object.keys(eventAttr).forEach(function (key) {
        if (key && protectedKeys.includes(key.toLowerCase())) {
          console.warn("\u8BF7\u52FF\u7528\u54C8\u52C3\u5185\u90E8\u4FDD\u7559\u5B57\u6BB5 ".concat(key, " \u8FDB\u884C\u4E0A\u62A5\uFF0C\u6B64\u64CD\u4F5C\u4F1A\u8986\u76D6\u539F\u6709\u4E0A\u62A5\u5B57\u6BB5\u3002\n\u672C\u6B21\u65E5\u5FD7\u4E3A ").concat(JSON.stringify(eventAttr, null, 4)));
        }
      });
    }, 100);
  }
}